import { HEALTHCARE_CAMPAIGNS_APPLICATIONS, SpecialistServicePath } from "utils/constants";
import permissions from "app/permissions";
import ListHealthcareCampaignApplication from "./List";
import CreateHealthcareCampaignApplication from "./Create";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";

export const resources = {
  isMenu: true,
  icon: <AssignmentIndIcon />,
  name: SpecialistServicePath + HEALTHCARE_CAMPAIGNS_APPLICATIONS,
  title: "Кандидатури - кампании за здравни грижи",
  list: <ListHealthcareCampaignApplication />,
  create: <CreateHealthcareCampaignApplication />,
  permission: permissions.canPreviewHealthcareCampaignApplications,
  createPermission: permissions.canManageHealthcareCampaignApplications,
};
